import {
    BreakpointRangeProps,
    Container,
    SelectionCardGroup,
    SelectionCardGroupProps,
    Stack,
    Typography,
} from '@optimus-web/core';
import { getTemplateColumnsGridSize } from '../../utils/getTemplateColumnsGridSize';

interface SuggestedCurrenciesProps extends BreakpointRangeProps {
    suggestedCurrenciesAriaLabelText: string;
    suggestedCurrenciesTitleText?: string;
    suggestedCurrenciesCardGroupOptions: SelectionCardGroupProps['options'];
    handleChange: (currencyCode: string | undefined) => void;
}

export const SuggestedCurrencies = ({
    suggestedCurrenciesTitleText,
    suggestedCurrenciesCardGroupOptions,
    suggestedCurrenciesAriaLabelText,
    breakpointRange,
    handleChange,
}: SuggestedCurrenciesProps) => {
    return (
        <Stack vertical>
            <Container padding={['0', '0', '300']}>
                <Typography textStyle="titleSmallStrong" as="div">
                    {suggestedCurrenciesTitleText}
                </Typography>
            </Container>

            <SelectionCardGroup
                inputValue={[]}
                onChange={(e_, newValue) => handleChange(newValue[0])}
                options={suggestedCurrenciesCardGroupOptions}
                showSelector={false}
                templateColumns={getTemplateColumnsGridSize(breakpointRange)}
                type="checkbox"
                aria-label={suggestedCurrenciesAriaLabelText}
            />
        </Stack>
    );
};
